import PropTypes from 'prop-types';

import Version2ProxyForm from './Version2ProxyForm';

function HeroSection({ onOpenTerms, t }) {
    return (
        <section className="hero section-panel">
            <div className="hero-orbit" aria-hidden="true" />
            <div className="content-width hero-content">
                <div className="hero-title">
                    <h1><span>{t('heroA')}</span><span>{t('heroB')}</span></h1>
                    <button className="agreement-card glass-card" type="button" onClick={onOpenTerms}>
                        <span className="status-dot" />
                        <span>{t('agreementBefore')} <u>{t('agreementLink')}</u></span>
                    </button>
                </div>
                <p className="hero-subtitle">{t('subtitle')}</p>
                <Version2ProxyForm placeholder={t('placeholder')} startLabel={t('start')} errorLabel={t('error')} />
            </div>
        </section>
    );
}

HeroSection.propTypes = {
    onOpenTerms: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default HeroSection;
